export default __webpack_public_path__ + "static/media/graduation-cap.37ec315d.svg";